import type { PartialVehicleData as VehicleData } from "shared/dist/types/vehicleData";

import { IMAGES_SERVER } from "@/config/settings";

export const CAIA_LOGO_URL = `${IMAGES_SERVER}/v2/items/C@IA.png`;

export const iframeSlidesLogin = ["https://splash.ia.parts", "about:_blank"];
export const iframeSlides = [
    "https://splash.ia.parts",
    "http://www.citroen.fr/accueil.html",
    "http://www.dsautomobiles.fr/accueil.html",
];
export const iframeSlidesCaridentifier = [
    {
        title: "Meetbox",
        img: `${IMAGES_SERVER}/v2/carH/equa_logo.png`,
        makeURL: (vd: VehicleData): string =>
            `https://meetbox.ia.parts/${vd.Codif_Vin_PRF}`,
    },
];
